<template>
  <div
    class="min-vh-100 w-100 d-flex align-items-center"
  >
    <b-container
      class="d-flex "
    >
      <b-row
        class="w-100"
        align-h="center"
      >
        <b-col
          xl="5"
          lg="5"
          md="5"
        >
          <b-card
            class="shadow-md border-0 my-5 card-style"
            no-body
          >
            <b-card-body
              class="p-0"
            >
              <div>
                <div
                  class="position-relative
                  d-flex flex-column
                  align-items-center justify-content-center"
                >
                  <div
                    class="text-white position-relative
                    d-flex flex-column
                    justify-content-center align-items-center
                    bg-login bg-login-gradient"
                  >
                    <CompanyLogo
                      white
                      class="company"
                    />
                    <!-- <div class="company-logo" /> -->
                    <div class="text-center company-name">
                      <b>Smart TV Analytics</b>
                    </div>
                    <div class="company-desc text-center">
                      This portal provides you insight into your Apps
                      and statistics of Samsung Smart TV environment
                    </div>
                  </div>
                </div>
                <b-overlay
                  rounded="sm"
                >
                  <div>
                    <div class="px-0">
                      <div
                        class="position-relative
                      d-flex flex-column align-items-center"
                      >
                        <span class="error-code-style">
                          403
                        </span>
                        <span class="forbidden-style">
                          Forbidden
                        </span>
                        <span class="forbidden-msg-style">
                          You do not have sufficient permissions
                        </span>
                        <hr class="solid">
                        <b-button
                          class="redirect-btn-style"
                          :href="'https://seller.samsungapps.com/tv/login'"
                        >
                          Go to seller office Log in
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-overlay>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable */
import CompanyLogo from '@/common/components/logo/CompanyLogo';
export default {
    components: {
        CompanyLogo,
    },
    data() {
        return {
            msg: 'You do not have sufficient permission'
        };
    }
}
</script>


<style lang="scss" scoped>

.card-style {
    border-radius: 26px;
}

.bg-login {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  border-top-right-radius: 26px !important;
  border-top-left-radius: 26px !important;
}

.bg-login-gradient {
  background-color: #0747A6;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
}

.company {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  left: 3rem;
  top: 2rem;
  height: 1rem;
}

.company-name {
  font-size: 2rem;
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
}

.company-desc {
  font-size: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-bottom: 3rem;
  color: #E8E8E8 !important;
}

.error-code-style {
    font-family: SamsungOne, Avenir, Helvetica, Arial, sans-serif;
    font-weight: 800;
    font-size: 250px;
    color: #F36773;
    line-height: 1;
    margin-top: 18px;
}

.forbidden-style {
    font-family: SamsungOne, Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 35px;
    color: #2C3052;
    line-height: 1;
    margin-top: 16px;
}

.forbidden-msg-style {
    font-family: SamsungOne, Avenir, Helvetica, Arial, sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #2C3052;
    line-height: 1;
    margin-top: 14px;
    margin-bottom: 4px;
}

.solid {
    border-top: 1.5px solid #D3D3D3;
    width: 80%;
}

.redirect-btn-style {
    background-color: #0747A6;
    width: fit-content;
    margin-top: 12px;
    margin-bottom: 25px;
}

</style>
